export function getCurrentMonth(): number{
    var date = new Date();
    let previousmonth = date.getMonth();
   return previousmonth;
}